import Button from '@cashew/button';
import { useEnterListener } from '@cashew/hooks';
import Input from '@cashew/input';
import { order } from '@cashew/types';
import { api, orderMapStatus } from '@cashew/utils';
import moment from 'moment';
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';

import './index.css';
import SelectComponent from '../../../components/SelectComponent';
import ExportModal from './ExportModal';

const statuses = [
  order.OrderStatusEnum.AUTHORISED,
  order.OrderStatusEnum.CONFIRMED,
  order.OrderStatusEnum.COMPLETED,
];
const searchByData = [
  {
    key: 'orderId',
    value: 'Order ID',
  },
  {
    key: 'reference',
    value: 'Merchant order code',
  },
];
const filterStatusDataArray = [
  {
    key: 'ALL',
    value: 'All',
  },
  {
    key: 'ACTIVE',
    value: 'Active',
  },
  {
    key: 'CANCELLED',
    value: 'Cancelled',
  },
];

export default ({
  setLoading,
  useSelector,
  type,
  setRecords,
  setList,
  pageSize,
  pageNumber,
  history,
  dispatch,
  records,
  setPageNumber,
}: any) => {
  const { token, selectedStore } = useSelector((state: any) => state.user);
  const [searchId, setSearchId] = useState('');
  const [searchBy, setSearchBy] = useState<string>('orderId');
  const [dateFrom, setDateFrom] = useState(
    moment().subtract(2, 'years').format('YYYY-MM-DD')
  );
  const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
  const [filterStatus, setFilterStatus] = useState('ALL');
  const [searchByDataFilter, setSearchByDataFilter] = useState(searchByData);
  const [filterParams, setFilterParams] = useState();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [dateToError, setDateToError] = useState('');
  const [dateFromError, setDateFromError] = useState('');
  const [enterBtn, setEnterBtn] = useState(false);
  const numericInput = /^[0-9]+$/;

  useEffect(() => {
    if (type !== 'customer') {
      setSearchByDataFilter([
        ...searchByDataFilter,
        {
          key: 'phoneNumber',
          value: 'Phone number',
        },
        {
          key: 'email',
          value: 'Email',
        },
        {
          key: 'nationalId',
          value: 'National ID',
        },
      ]);
    }
  }, []);

  const getOrdersApi = (resetPageNumber = true) => {
    if (resetPageNumber && pageNumber !== 0) {
      setPageNumber(0);
      return;
    }

    setLoading(true);
    let statusesArray = statuses;
    let status = statuses.join();
    switch (filterStatus) {
      case 'ALL':
        statusesArray = [...statuses, order.OrderStatusEnum.CANCELLED];
        status = statusesArray.join();
        break;
      case 'ACTIVE':
        status = statuses.join();
        break;
      case 'CANCELLED':
        status = order.OrderStatusEnum.CANCELLED;
        break;
      default:
        status = statuses.join();
    }
    const params: any = {
      page: pageNumber,
      size: pageSize,
      storeId: selectedStore > 0 ? selectedStore : null,
      status,
      refundStatus: null,
      dateFrom,
      dateTo,
    };
    if (searchId && searchBy) {
      params[searchBy] = searchId;
    }
    setFilterParams(params);
    api
					.get({
						endpoint: 'orders/subscriptions',
						params,
						headers: {
							Authorization: token,
						},
					})
					.then((resp) => {
						setLoading(false);
						setRecords(resp.totalCount);
						const formatList = resp.data.map((item: any) => {
							if (item.orderStatus !== 'CANCELLED') {
								status = 'ACTIVE';
							} else {
								status = 'CANCELLED';
							}
							if (type === 'admin') {
								const formattedStatus = orderMapStatus({
									type: 'subscription',
									status: item.orderStatus,
								});
								status = formattedStatus.label;
							} else if (item.orderStatus !== 'CANCELLED') {
								status = 'ACTIVE';
							} else {
								status = 'CANCELLED';
							}
							const name = item.customer?.firstName
								? `${item.customer?.firstName} ${item.customer?.lastName}`
								: '';

							return {
								...item,
								type,
								email: item.customer?.email,
								name,
								status,
								orderDate: item.orderDate,
							};
						});
						setList(formatList);
					})
					.catch((resp) => {
						setLoading(false);
						api.errorHandler({
							resp,
							history,
							dispatch,
							callback: () => {
								dispatch({
									type: 'OPEN_TOASTER',
									payload: {
										toasterTitle: 'Fetch orders',
										toasterMessage: 'Error fetching orders',
										toasterType: 'error',
										toasterVisible: true,
									},
								});
							},
						});
					});
  };
  useEnterListener(() => setEnterBtn((prev) => !prev));

  useEffect(() => {
    getOrdersApi();
  }, [filterStatus, selectedStore, dateFrom, dateTo, enterBtn]);

  useEffect(() => {
    setSearchId('');
  }, [searchBy]);

  useEffect(() => {
    getOrdersApi(false);
  }, [pageNumber, pageSize]);

  const getExcelReport = () => {
    api
					.get({
						endpoint: 'orders/subscriptions/excel',
						responseType: 'blob',
						params: filterParams,
						headers: {
							Authorization: token,
						},
					})
					.then((response) => {
						const [firstDate, secondDate] = new Date()
							.toLocaleString('no-nb')
							.split(',');
						const name = [
							...firstDate.split('/'),
							...secondDate.trim().split(':'),
						].join('-');
						const xhr = new XMLHttpRequest();
						xhr.responseType = 'blob';
						const blob = response;
						const a = window.document.createElement('a');
						a.href = window.URL.createObjectURL(blob);
						a.download = `Subscriptions_report_${name}.xlsx`;
						document.body.appendChild(a);
						a.click();
						document.body.removeChild(a);
					})
					.catch((resp) => {
						setLoading(false);
						api.errorHandler({
							resp,
							history,
							dispatch,
							callback: () => {
								dispatch({
									type: 'OPEN_TOASTER',
									payload: {
										toasterTitle: 'Fetch orders',
										toasterMessage: 'Error fetching orders',
										toasterType: 'error',
										toasterVisible: true,
									},
								});
							},
						});
					});
  };

  return (
    <>
      <div className="filters">
        <div className="filter-group">
          <div className="filter-input">
            <SelectComponent
              label="Search by"
              data={searchByDataFilter}
              selected={searchBy}
              onSelect={setSearchBy}
            />
          </div>
          <div className="filter-input">
            <Input
              name="orderId"
              value={searchId}
              maxLength={searchBy === 'orderId' ? 14 : 100}
              type="text"
              onChange={(e: any) => {
                const searchValue = e.target.value;
                if (searchBy === 'orderId') {
                  if (searchValue.match(numericInput) || searchValue === '') {
                    setSearchId(searchValue);
                  }
                } else {
                  setSearchId(searchValue);
                }
              }}
            />
          </div>
          <div className="filter-input">
            <Button extraClass="btn blue" onClick={() => getOrdersApi()}>
              Search
            </Button>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input">
            <label>From</label>
            <Input
              name="dateFrom"
              value={moment(dateFrom).format('YYYY-MM-DD')}
              type="date"
              error={dateFromError ? ' ' : ''}
              onChange={(e: any) => {
                setDateFrom(moment(e.currentTarget.value).format('YYYY-MM-DD'));
                setDateToError('');
                if (moment(e.currentTarget.value).isAfter(dateTo) && dateTo) {
                  setDateFromError('should be less than To date');
                } else {
                  setDateFromError('');
                }
              }}
            />
            <span className="error-message">{dateFromError}</span>
          </div>
          <div className="filter-input">
            <span>To</span>
            <Input
              name="dateTo"
              value={moment(dateTo).format('YYYY-MM-DD')}
              type="date"
              error={dateToError ? ' ' : ''}
              onChange={(e: any) => {
                setDateTo(moment(e.currentTarget.value).format('YYYY-MM-DD'));
                setDateFromError('');
                if (
                  moment(e.currentTarget.value).isBefore(dateFrom) &&
                  dateFrom
                ) {
                  setDateToError('should be greater than From date');
                } else {
                  setDateToError('');
                }
              }}
            />
            <span className="error-message">{dateToError}</span>
          </div>
        </div>
        <div className="filter-group">
          <div className="filter-input status-dropdown">
            <SelectComponent
              label="Status"
              data={filterStatusDataArray}
              selected={filterStatus}
              onSelect={setFilterStatus}
            />
          </div>
          {(type === 'cashew' || type === 'merchant') && (
            <div className="filter-input">
              <Button
                extraClass={records ? 'btn blue' : ''}
                disabled={!records}
                onClick={() => setShowCancelModal(true)}
              >
                Export to Excel
              </Button>
            </div>
          )}
        </div>
      </div>
      {(type === 'cashew' || type === 'merchant') && (
        <ExportModal
          showConfirmModal={showCancelModal}
          setShowConfirmModal={setShowCancelModal}
          token={token}
          history={history}
          dispatch={dispatch}
          getExcelReport={getExcelReport}
          records={records}
        />
      )}
    </>
  );
};
